export const SET_STEP = 'configurator/SET_STEP';

export const GO_TO_PREV_STEP = 'configurator/GO_TO_PREV_STEP';

export const GO_TO_NEXT_STEP = 'configurator/GO_TO_NEXT_STEP';

export const TOGGLE_SIDE = 'configurator/TOGGLE_SIDE';

export const TOGGLE_FULLSCREEN = 'configurator/TOGGLE_FULLSCREEN';

export const SET_ACCESSORIES_CATEGORY = 'configurator/SET_ACCESSORIES_CATEGORY';

export const SET_ACCESSORIES_SORT = 'configurator/SET_ACCESSORIES_SORT';

export const SET_ACCESSORIES_QUERY = 'configurator/SET_ACCESSORIES_QUERY';

export const SET_ACCESSORIES_PAGE = 'configurator/SET_ACCESSORIES_PAGE';

export const SET_MODAL_PROPS = 'configurator/SET_MODAL_PROPS';

export const OPEN_MODAL = 'configurator/OPEN_MODAL';

export const CLOSE_MODAL = 'configurator/CLOSE_MODAL';

export const OPEN_DISCLAIMER = 'configurator/OPEN_DISCLAIMER';

export const CLOSE_DISCLAIMER = 'configurator/CLOSE_DISCLAIMER';

export const SET_SELECTED_DISCLAIMER = 'configurator/SET_SELECTED_DISCLAIMER';

export const RESET_CONFIGURATOR = 'configurator/RESET_CONFIGURATOR';

export const SET_ACCESSORY_ITEMS = 'configurator/SET_ACCESSORY_ITEMS';

export const SET_ACCESSORY_CATEGORIES = 'configurator/SET_ACCESSORY_CATEGORIES';

export const SET_ACCESSORY_EXTRAS = 'configurator/SET_ACCESSORY_EXTRAS';

export const PREVIEW_ACCESSORY = 'configurator/PREVIEW_ACCESSORY';

export const FLIP_BIKE = 'configurator/FLIP_BIKE';

export const CLOSE_ALL_MODALS = 'configurator/CLOSE_ALL_MODALS';

export const ZOOM_ON = 'configurator/ZOOM_ON';

export const ZOOM_OFF = 'configurator/ZOOM_OFF';

export const SET_SCROLL_Y_POSITION = 'configurator/SET_SCROLL_Y_POSITION';

export const SET_SCROLL_X_POSITION = 'configurator/SET_SCROLL_X_POSITION';

export const SET_PACKS = 'configurator/SET_PACKS';

export const SET_PRINT_ACTIONS = 'configurator/SET_PRINT_ACTIONS';
